import React from 'react';
import { Modal, Button, Row, Col, Badge } from 'react-bootstrap';
import { getUserData } from '../utils/util';

const UserProfileModal = ({ show, onHide }) => {
  const user = getUserData() || {};
  const { ruc, emp, dir, nom, eml, rol, usr } = user;
  const getRoleLabel = (rol) => {
    switch(String(rol)) {
      case '1': return 'Admin';
      case '2': return 'Contador';
      case '3': return 'Cajero';
      case '4': return 'Vendedor';
      case '99': return 'Master';
      default: return rol ? 'Desconocido' : 'N/A';
    }
  };
  const roleLabel = getRoleLabel(rol);
  const getBadgeColor = (rol) => {
    switch(String(rol)) {
      case '1': return 'danger';  // Admin en rojo
      case '2': return 'success'; // Contador en verde
      case '3': return 'info';    // Cajero en azul
      case '4': return 'warning'; // Vendedor en amarillo
      case '99': return 'warning'; // Master en amarillo
      default: return 'secondary'; // Desconocido en gris
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Perfil de usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2">
          <Col xs={4}><strong>RUC</strong></Col>
          <Col>{ruc || '-'}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>Empresa</strong></Col>
          <Col>{emp || '-'}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>Dirección</strong></Col>
          <Col style={{ whiteSpace: 'pre-wrap' }}>{dir || '-'}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>Nombre</strong></Col>
          <Col>{nom || usr || '-'}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>Email</strong></Col>
          <Col>{eml || '-'}</Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col xs={4}><strong>Rol</strong></Col>
          <Col><Badge bg={getBadgeColor(rol)} pill>{roleLabel}</Badge></Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>Usuario</strong></Col>
          <Col>{usr || '-'}</Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserProfileModal;
